<div>
  <symbol-search
    [isAllMFSearch]="true"
    [selectedValue]="currentValue"
    [placeholder]="'Search'"
    (selected)="symbolFilterSelected($event)">
  </symbol-search>
</div>
